import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { getPositiveListErrorKey } from "../helpers/apiError";
import { refreshPositiveListMeasure } from "../helpers/cache";

const useUpdatePositiveListMeasure = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ measureId, payload }) => {
            const service = PositiveListService.getInstance();

            return await service.updateMeasure(measureId, payload);
        },
        onSuccess: async (measure, variables) => {
            const patch = measure && typeof measure === "object"
                ? ["title", "description", "measure_type", "adoption_type"].reduce((next, field) => {
                    if (measure[field] !== undefined) {
                        next[field] = measure[field];
                    }

                    return next;
                }, {})
                : null;

            await refreshPositiveListMeasure(queryClient, {
                softwareId,
                measureId: variables.measureId || measure?.id,
                patch: patch && Object.keys(patch).length ? patch : null,
                confirm: (detail) => (
                    !patch?.title || detail?.title === patch.title
                ),
            });
            toast(t("Measure updated."), { type: "success" });

            if (typeof onSuccess === "function") {
                onSuccess(measure);
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t(getPositiveListErrorKey(error) || "An error occurred while saving the measure."),
                { type: "error" }
            );
        },
    });
};

export default useUpdatePositiveListMeasure;
